import { Button, Stack } from "@mui/material";
import type { FC } from "react";
import { MonthlySavingsHero } from "web_myplann/Goals/Components/MonthlySavingsHero";
import { monthlyContribution } from "web_myplann/Goals/Helpers/monthlyContribution";
import { monthsUntil } from "web_myplann/Goals/Helpers/monthsUntil";

type Props = {
	savingsTarget: number;
	dueDate: Date | undefined | null;
	submitLabel: string;
	cancelLabel: string;
	submitDisabled: boolean;
	isSubmitting: boolean;
	onCancel: () => void;
};

export const MonthlySavingsConversion: FC<Props> = ({
	savingsTarget,
	dueDate,
	submitLabel,
	cancelLabel,
	submitDisabled,
	isSubmitting,
	onCancel,
}) => {
	const hasHero =
		savingsTarget > 0 &&
		monthsUntil(dueDate) > 0 &&
		monthlyContribution(savingsTarget, dueDate) > 0;

	if (hasHero) {
		return (
			<MonthlySavingsHero
				savingsTarget={savingsTarget}
				dueDate={dueDate}
				submitLabel={submitLabel}
				cancelLabel={cancelLabel}
				submitDisabled={submitDisabled}
				isSubmitting={isSubmitting}
				onCancel={onCancel}
			/>
		);
	}

	return (
		<Stack px={1.6} pt={2.4} pb={3.2} gap={1.2}>
			<Button
				type="submit"
				variant="primary"
				disabled={submitDisabled}
				loading={isSubmitting}
			>
				{submitLabel}
			</Button>
			<Button variant="secondary" onClick={onCancel}>
				{cancelLabel}
			</Button>
		</Stack>
	);
};
